import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { GridModule } from '@progress/kendo-angular-grid';
import { UploadsModule } from '@progress/kendo-angular-upload';
import { IndicatorsModule } from '@progress/kendo-angular-indicators';
import { SharedModule } from '../shared/shared.module';
import { InventoryViewComponent } from './inventory-view/inventory-view.component';
import { InventoryDetailComponent } from './inventory-detail/inventory-detail.component';
import { InventoryDetailServicesComponent } from './inventory-detail/inventory-detail-services/inventory-detail-services.component';
import { InventoryDetailAttachmentsComponent } from './inventory-detail/inventory-detail-attachments/inventory-detail-attachments.component';

@NgModule({
  declarations: [
    InventoryViewComponent,
    InventoryDetailComponent,
    InventoryDetailServicesComponent,
    InventoryDetailAttachmentsComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    GridModule,
    UploadsModule,
    DateInputsModule,
    IndicatorsModule,
    SharedModule
  ]
})
export class InventoryModule { }